import React, { useRef } from 'react';
import { AlertDialog, AlertDialogOverlay } from '@chakra-ui/react';
import { AlertDialogContent } from '../UI-CHAKRA/Dialog/AlertDialogContent';
import { ResponsiveObject } from '@chakra-ui/react';

type BaseDialogProps = {
  isOpen: boolean;
  onChange?(open: boolean): void;
  children: React.ReactNode | React.ReactNode[];
  persist?: boolean;
  onClose(): void;
  onOverlayClick?(): void;
  hideCloseButton?: boolean;
  width?: string | ResponsiveObject<string>;
  stylesCustom?: { [key: string]: string };
};

const Dialogs: React.FC<BaseDialogProps> = (props) => {
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      isOpen={props.isOpen}
      leastDestructiveRef={cancelRef}
      onClose={() => props.onClose()}
      onOverlayClick={() => !props.persist && props.onOverlayClick && props.onOverlayClick()}
      isCentered
      closeOnOverlayClick={!props.persist}
    >
      <AlertDialogOverlay bg={'rgba(30, 37, 43, 0.5)'}>
        <AlertDialogContent w={props.width} maxW={props.width} padding="30px" style={{ ...props.stylesCustom }}>
          {props.children}
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default Dialogs;
